import PayoutToken from '@apps/maha/admin/tokens/payout'
import StatusToken from '@admin/tokens/status'
import Panel from '@admin/components/panel'
import Payout from '../payout'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Payouts)',
  collection: {
    endpoint: `/api/admin/truevail/admin/affiliates/${props.affiliate.id}/payouts`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Payout)', key: 'date', primary: true, format: (payout) => (
        <PayoutToken payout={ payout } />
      ) },
      { label: 't(Payments)', key: 'payments_count', collapsing: true, align: 'right' },
      { label: 't(Commision)', key: 'total', collapsing: true, align: 'right', format: 'currency' },
      { label: 't(Status)', key: 'status', collapsing: true, format: StatusToken }
    ],
    empty: {
      title: 't(No Payouts)',
      text: 't(There are no payouts for this affiliate)',
      svg: 'hand_coins',
      buttons: [
        {
          label: 't(Create Payout)',
          modal: <Payout affiliate={ props.affiliate } />
        }
      ]
    },
    entity: 'team',
    defaultSort: { key: 'created_at', order: 'desc' },
    onClick: (record) => context.router.push(`/admin/truevail/admin/payouts/${record.id}`)
  },
  task: {
    svg: 'plus',
    tooltip: 't(Create Payout)',
    modal: <Payout affiliate={ props.affiliate } />
  }
})

export default Panel(null, mapPropsToPanel)
